<template>
  <div
    :class="{
      'mobile-header-wrapper': true,
      'is-searchable-view': currentViewIsSearchable,
    }"
  >
    <w-speed-dial v-if="isNavigationDrawerVisible">
      <w-speed-dial-button
        icon="$wHamburgerMenu"
        :label="$t('Common.menu')"
        @click="openNavigationDrawer"
      />
    </w-speed-dial>
    <WorkBaseHeaderBar>
      <template #logo>
        <w-btn
          class="logo sidebar-icon"
          :disabled="isSidebarDrawerOpen"
          :icon="true"
          @click="openSidebarDrawer"
        >
          <w-icon>
            {{ isSidebarDrawerOpen ? '$wNavCollapse' : '$wNavExpand' }}
          </w-icon>
        </w-btn>
      </template>

      <template #search-action>
        <WorkHeaderSearchField />
      </template>

      <template #append-actions>
        <div
          class="work-logo"
          @click="goToNavigation"
        >
          <img
            v-if="isProdMode"
            src="../../assets/header/work_logo_white_mobile.svg"
            class="logo work-logo-append"
          >
          <img
            v-else
            src="../../assets/header/work_logo_white_mobile_test.svg"
            class="logo work-logo-append work-logo-test"
          >
        </div>
      </template>
    </WorkBaseHeaderBar>
    <WorkMobileHeaderMenu 
      :go-to-dashboard="goToDashboard"
      :go-to-navigation="goToNavigation"
      :go-to-open-windows="goToOpenWindows"
      :go-to-user-profile="goToUserProfile"
      :show-deputy-modal="showDeputyModal"
      :show-dashboard="showDashboard"
      :logout-as-deputy="logoutAsDeputy"
      :deputy-exists="deputyExists"
      :logout="logout"
    />
  </div>
</template>

<script>
//components
import WorkBaseHeaderBar from './WorkBaseHeaderBar';
import WorkHeaderSearchField from './components/WorkHeaderSearchField';
import WorkMobileHeaderMenu from './WorkMobileHeaderMenu.vue';

//helpers
import { mapState } from 'vuex';
import { mapActions, mapGetters } from 'vuex';
//mixins
import changeInstanceMixin from "@/mixins/mobile_wrapper/change-instance-mixin";
import dynamicData from '@/mixins/api_data/dynamic-data-mixin';
import openHelpMenuMixin from "@/mixins/mobile_wrapper/open-help-menu-mixin";

export default {
  name: 'WorkMobileHeaderBar',
  components: {
    WorkHeaderSearchField,
    WorkBaseHeaderBar,
    WorkMobileHeaderMenu,
  },
  mixins: [
    changeInstanceMixin,
    openHelpMenuMixin,
    dynamicData('systeminfo', 'system/information'),
  ],
  props: {
    showDashboard: { type: Boolean, default: true },
    // Help
    showHelpWindow: { type: Function, required: true },
    // Go To
    goToNavigation: { type: Function, required: true },
    goToOpenWindows: { type: Function, required: true },
    goToDashboard: { type: Function, required: true },
    // Theme
    toggleTheme: { type: Function, required: true },
    // Settings
    goToUserProfile: { type: Function, required: true },
    // Acting User
    showDeputyModal: { type: Function, required: true },
    logoutAsDeputy: { type: Function, required: true },
    // logout
    logout: { type: Function, required: true },
    // data
    deputyExists: { type: Number },
    languages: { type: Array, required: true },
  },
  computed: {
    ...mapState(['activeModule']),
    ...mapGetters('navigationDrawer', ['isNavigationDrawerVisible', 'isNavigationDrawerOpen']),
    ...mapGetters('sidebarDrawer', ['isSidebarDrawerOpen']),
    currentViewIsSearchable() {
      return this.activeModule.isSearchable;
    },
    isProdMode() {
      return this.systeminfo.mode === "prod";
    },
  },
  methods: {
    ...mapActions('navigationDrawer', ['setNavigationDrawerIsOpen']),
    ...mapActions('sidebarDrawer', ['setSidebarDrawerIsOpen']),
    openNavigationDrawer(){
      this.setNavigationDrawerIsOpen(!this.isNavigationDrawerOpen);
    },
    openSidebarDrawer(){
      this.setSidebarDrawerIsOpen(!this.isSidebarDrawerOpen);
    },
    goToComponent(component) {
      this.$router.push({ 
        name: component
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.mobile-header-wrapper {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    &.is-searchable-view {
      .work-header-bar .v-toolbar__content {
        .spacer {
          display: none !important;
        }

        .work-header-search-field {
          flex-grow: 1 !important;

          input.visible-search-input {
            width: 100% !important;
          }
        }
      }
    }
  }

  .work-header-bar .active-module-name h1 {
    font-size: 1.5rem;
  }

  .work-app-vertical-spacer {
    margin-left: 0.625rem !important;
  }

  $logo-size: 2rem;
  .work-logo {
    height: $logo-size;

    .logo {
      height: $logo-size !important;
      width: $logo-size !important;

      &.work-logo-append {
        margin-left: 0.313rem;
        
        &.work-logo-test {
          padding-bottom: 0.5rem;
        }
      }
      &.sidebar-icon{
        background-color: transparent !important;

        &.v-btn--disabled.theme--dark {
          background-color: transparent !important;
        }

        svg.v-icon__component.theme--dark.primary--text {
          color: $sidebar-mobile-collapse-icon !important;
      }
      }
    }
  }
}

</style>
